import { useEffect, useMemo } from 'react';

import { useFormContext } from '@/components/react-hook-form';
import { getTaxStatusValuesFromEntityType } from '@/modules/entities/TaxStatusSubform/TaxStatusSubform.utils';
import { EntityType } from '@/modules/entities/types/EntityType';

import { EntityShortFormShape } from '../CreateEntityShortForm.types';

interface UseDefaultEstateInclusionStatusParams {
  entityType: EntityType;
}

export function useDefaultEstateInclusionStatus({
  entityType,
}: UseDefaultEstateInclusionStatusParams) {
  const { resetField } = useFormContext<EntityShortFormShape>();

  // we want to default the estate inclusion status to the default for the
  // entity type, but still allow users to change it
  const estateInclusionStatus = useMemo(() => {
    const taxStatusFormDefaultValues =
      getTaxStatusValuesFromEntityType(entityType);
    return taxStatusFormDefaultValues.estateInclusionStatus;
  }, [entityType]);

  useEffect(() => {
    resetField('createEntityShortForm.estateInclusionStatus', {
      defaultValue: estateInclusionStatus,
    });
  }, [estateInclusionStatus, resetField]);

  // Default the entity-level state in-estate field to mirror the federal
  // default. The user can still change it.
  useEffect(() => {
    resetField('createEntityShortForm.stateInEstateStatus', {
      defaultValue: estateInclusionStatus,
    });
  }, [estateInclusionStatus, resetField]);
}
